import React, { useState, useEffect } from "react";
import { ManageInnerCat } from "../Logics";
import {
  ManageInnerCategory,
  showMessage,
} from "../../../Functionalities/Functions";

function ProductMenusSection({ data, tagList, remainingList, setremainingList, getData }) {
  const [addMenu, setaddMenu] = useState(false);
  const [selectedMenu, setselectedMenu] = useState("");

  return (
    <div>
      <div className="row">
        {data.inner_category &&
          data.inner_category.map((tag, index) => {
            return (
              <div
                key={tag.id || index}
                className="col-3"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-around",
                  borderRadius: "20px",
                  backgroundColor: "#46B23C",
                  margin: "8px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                    padding: "0 5px",
                  }}
                >
                  <h6
                    style={{
                      margin: "6px",
                      color: "white",
                      fontSize: "14px",
                    }}
                  >
                    {tag.name}
                  </h6>
                  {data.inner_category.length > 1 && (
                    <span
                      style={{
                        fontSize: 16,
                        height: "20px",
                        width: "20px",
                        cursor: "pointer",
                        marginTop: 5,
                        marginLeft: 10,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "red",
                        borderRadius: "5px",
                        backgroundColor: "white",
                      }}
                      onClick={(e) => {
                        ManageInnerCat(
                          e,
                          "patch",
                          [
                            {
                              keyword: "remove_inner_cat_product",
                            },
                            { list: tag.id },
                            { id: data.id },
                          ],
                          ""
                        )
                          .then((res) => {
                            if (res.data.Status === true) {
                              showMessage(
                                "Category tag updated",
                                "success",
                                "success!",
                                "top",
                                "top-right",
                                0
                              );
                              getData();
                            } else {
                              showMessage(
                                "Error",
                                "Error",
                                "Danger!",
                                "top",
                                "top-right",
                                0
                              );
                            }
                          })
                          .catch((err) => {});
                      }}
                    >
                      <i className="fa fa-trash-o text-danger"></i>
                    </span>
                  )}
                </div>
              </div>
            );
          })}
      </div>
      {!addMenu ? (
        <p className="mt-3">
          <span
            onClick={() => setaddMenu(true)}
            className="item badge badge-circle badge-success"
            style={{ cursor: "pointer" }}
          >
            <i className="ti-plus"></i>
          </span>{" "}
          Add Menu
        </p>
      ) : (
        <div className="form-group row mt-3">
          <label className="col-sm-12 col-form-label">Choose Menus : </label>
          <div className="col-sm-8">
            <select
              name="categoryid1"
              value={selectedMenu}
              onChange={(e) => setselectedMenu(e.target.value)}
              className="form-control"
              data-placeholder="Choose Slots"
              tabIndex={-1}
              aria-hidden="true"
            >
              <option value={""}>{"------Menu------"}</option>
              {remainingList.map((item, index) => (
                <option key={index} value={item.id}>
                  {item.name}
                </option>
              ))}
            </select>
          </div>
          <div className="col-sm-3">
            <button
              className="submit btn btn-primary"
              name="submit"
              onClick={(e) => {
                e.preventDefault();
                if (!selectedMenu) {
                  showMessage(
                    "Please select a menu",
                    "danger",
                    "Validation Error",
                    "top",
                    "top-right",
                    0
                  );
                  return;
                }
                ManageInnerCat(
                  e,
                  "patch",
                  [
                    { keyword: "add_inner_cat_product" },
                    { list: selectedMenu },
                    { id: data.id },
                  ],
                  ""
                )
                  .then((res) => {
                    if (res.data.Status === true) {
                      showMessage(
                        "Menu updated",
                        "success",
                        "success!",
                        "top",
                        "top-right",
                        0
                      );
                      setaddMenu(false);
                      getData();
                    }
                  })
                  .catch((err) => {});
              }}
            >
              Save
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default ProductMenusSection;
